<template>
  <Class />
</template>

<script>
import Class from '@/components/content/classes/SelectedClass.vue'

export default {
  name: 'ClassPage',
  components: { Class }
}
</script>

<style scoped>

</style>
